import * as React from "react";
import { AccordionItem } from "@grandvisionhq/common";
import { useFacetLabel } from "../../../../../hooks/Algolia/hooks/use-facet-label.js";
import { useSearchableRefinementList } from "../../../../../hooks/Algolia/hooks/use-searchable-refinement-list.js";
import { FacetSearchBox } from "../../../../FacetSearchBox/Algolia/components/FacetSearchBox/FacetSearchBox.js";
import RefinementItem from "../../../../RefinementItem/Algolia/components/RefinementItem/RefinementItem.js";
/* empty css                          */
const FacetContainerMobile = ({ facet, onChange }) => {
  const { sortedItems, refine, isFromSearch, setQuery } = useSearchableRefinementList({
    facet
  });
  const label = useFacetLabel({ facet });
  if (!sortedItems.length && !isFromSearch) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(AccordionItem, { id: facet.id, label, headingLevel: "h3", className: "facet-container-mobile" }, facet.searchable && /* @__PURE__ */ React.createElement(FacetSearchBox, { onSearch: setQuery, className: "facet-container-mobile__search" }), /* @__PURE__ */ React.createElement("fieldset", null, sortedItems.map((item) => /* @__PURE__ */ React.createElement(
    RefinementItem,
    {
      key: item.label,
      item,
      facet,
      onRefine: refine,
      onChange
    }
  ))));
};
export {
  FacetContainerMobile
};
//# sourceMappingURL=FacetContainerMobile.js.map
